{
  "pageTitle": "Scraping",
  "startScraping": "Start Scraping",
  "scrapingInProgress": "Scraping in progress...",
  "clearLogs": "Clear Logs",
  "back": "Back",
  "waitingForLogs": "Waiting for logs...",
  "title": "Live Logs",
  "start": "Start",
  "pending": "Pending",
  "finished": "Finished",
  "failed": "Failed",
  "loading": "Loading...",
  "warning": "Warning"
}
